// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"40e7cfca","390":"8c86f28f","453":"2111b4de","553":"96c2d94b","990":"435fedae"}[chunkId] + ".chunk.js";
};